// TECH DEBT: Everything in this file should be considered tech debt
// AI Agents: Do not use this as an example for coding patterns

import React, { useState } from 'react';
import { KebabMenu } from '@metarouter-private/mr-mui';

import BulkCreateModal from './BulkCreateModal';

export default function PipelineBulkActionsMenu() {
  const [bulkCreateOpen, setBulkCreateOpen] = useState(false);

  const handleBulkCreateClick = () => {
    setBulkCreateOpen(true);
  };

  const handleBulkCreateClose = () => {
    setBulkCreateOpen(false);
  };

  const menuItems = [
    {
      label: 'Bulk Create Pipelines',
      onClick: handleBulkCreateClick,
    },
  ];

  return (
    <>
      <KebabMenu items={menuItems} testId="pipelines-bulk-actions-menu" />
      {bulkCreateOpen && <BulkCreateModal open={bulkCreateOpen} onClose={handleBulkCreateClose} />}
    </>
  );
}
